import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.896 8.454v8.784c0 1.835-.935 2.762-2.797 2.762H4.88c-1.862 0-2.798-.918-2.798-2.762V8.454c0-1.844.936-2.761 2.798-2.761h2.726v1.434H4.898c-.89 0-1.38.472-1.38 1.399v8.641c0 .926.49 1.399 1.38 1.399h10.174c.882 0 1.39-.473 1.39-1.399V8.526c0-.927-.508-1.399-1.39-1.399h-2.708V5.693h2.735c1.862 0 2.797.926 2.797 2.761"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.985 13.025c.383 0 .713-.312.713-.687v-9.06l-.053-1.327.498.526 1.372 1.47a.65.65 0 0 0 .481.213c.375 0 .65-.267.65-.623a.63.63 0 0 0-.204-.472L10.502.232C10.324.053 10.172 0 9.985 0c-.178 0-.33.053-.516.232L6.538 3.065c-.134.133-.214.276-.214.472 0 .356.267.623.641.623a.67.67 0 0 0 .49-.213l1.381-1.47.499-.526-.053 1.327v9.06c0 .375.32.687.703.687"
    }, null, -1)
  ])))
}
export default { render: render }